// extracted by mini-css-extract-plugin
export default {"carouselimage":"carousel_carouselimage__YNheO"};